import { Injectable } from '@angular/core';

/**
 * Holds the transaction list's virtual-scroll offset across navigations, so
 * returning from a detail page puts the user back where they left the list.
 * The offset is written when the list component is destroyed and consumed
 * (one-shot) when the viewport is recreated, so a refresh that rebuilds the
 * viewport mid-session doesn't re-apply a stale position.
 */
@Injectable({ providedIn: 'root' })
export class TransactionsListScrollService {
  private offset = 0;

  save(offset: number): void {
    this.offset = offset;
  }

  consume(): number {
    const offset = this.offset;
    this.offset = 0;
    return offset;
  }
}
